<template>
  <month-year-picker v-if="!readOnly && !field.readOnly"
                     ref="inputRef"
                     :value="fieldValue"
                     :required="maybeCall(field.required, value)"
                     :hint="field.hint"
                     :persistent-hint="true"
                     :disabled="field.disabled"
                     :label="label"
                     :rules="validationRules"
                     :prepend-icon="field.prependIcon"
                     :clearable="field.clearable"
                     :box="box || field.box"
                     :min="field.min"
                     :max="field.max"
                     @input="onMonthYearChange" />
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p v-if="field.hint" class="text-caption primary--text">
      {{ field.hint }}
    </p>
    <p>{{ formattedValue || '-' }}</p>
  </div>
</template>

<script>
import { defineComponent, toRef, computed } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'
import MonthYearPicker from '~shared/fields/MonthYearPicker.vue'

export default defineComponent({
  name: 'DynamicMonthYearField',
  components: {
    MonthYearPicker
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      label,
      inputRef,
      maybeCall,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: null,
      emit
    })

    const onMonthYearChange = (value) => {
      fieldValue.value = value
      fieldChanged(value)
    }

    const formattedValue = computed(() => {
      if (!fieldValue.value) return null
      
      if (typeof fieldValue.value === 'object' && fieldValue.value.year && fieldValue.value.month) {
        const monthNames = [
          'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
          'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ]
        return `${monthNames[fieldValue.value.month - 1]}/${fieldValue.value.year}`
      }
      
      return fieldValue.value
    })

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      label,
      inputRef,
      maybeCall,
      onMonthYearChange,
      formattedValue
    }
  }
})
</script>